
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../App.css';
import {adminLogin} from "../../api";

const Enter = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await adminLogin(email,password)
            navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#ccdff5',
            padding: '20px'
        }}>
            <div style={{
                background: '#F6F6F6',
                borderRadius: '20px',
                padding: '40px',
                boxShadow: '0 4px 24px rgba(44, 62, 80, 0.08)',
                maxWidth: '400px',
                width: '100%'
            }}>
                <h2 style={{
                    color: '#3c5a5d',
                    marginBottom: '30px',
                    textAlign: 'center',
                    fontSize: '2rem'
                }}>
                    Login
                </h2>
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            color: '#3c5a5d',
                            fontWeight: '600'
                        }}>
                            Email
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                borderRadius: '14px',
                                border: '1px solid #cfd8dc',
                                background: '#e5eff8',
                                fontSize: '16px',
                                color: '#0c1415'
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            color: '#3c5a5d',
                            fontWeight: '600'
                        }}>
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                borderRadius: '14px',
                                border: '1px solid #cfd8dc',
                                background: '#e5eff8',
                                fontSize: '16px',
                                color: '#0c1415'
                            }}
                        />
                    </div>
                    {error && (
                        <div style={{
                            color: '#dc2626',
                            marginBottom: '20px',
                            padding: '12px',
                            background: '#fee2e2',
                            borderRadius: '8px',
                            fontSize: '14px'
                        }}>
                            {error}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-primary"
                        style={{
                            width: '100%',
                            padding: '15px',
                            fontSize: '16px'
                        }}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Enter;
